// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b7b6140b","453":"9a6fbfff","732":"cf88d5c9"}[chunkId] + ".chunk.js";
};